import useDefinedContext from "hooks/useDefinedContext";
import { InitialLoaderActionsContext } from "../InitialLoaderProvider";

interface UseInitialLoaderActionsProps {}

function useInitialLoaderActions(props?: UseInitialLoaderActionsProps) {
  return useDefinedContext(InitialLoaderActionsContext);
}

export default useInitialLoaderActions;
